import {connect} from 'react-redux';
import {List} from 'immutable';

import {
  loadCareGuideHelperTag,
  updateCareGuideHelperTag,
  createCareGuideHelperTag,
  deleteCareGuideHelperTag,
  careGuideHelperTagFormDestroy
} from '../../../../../state/modules/careGuideHelperTags/actions';
import {sendMessage} from '../../../../../state/actions';
import CareGuideHelperTagForm from '../components/CareGuideHelperTagForm';

const inputs = List([
  'label',
  'status'
]);

const mapStateToProps = (state, ownProps) => {

  const data = {}, errors = {};
  for (const val of inputs.values()) {
    data[val] = state.entities.getIn(['careGuideHelperTags', ownProps.id, val], '');
    errors[val] = state.careGuideHelperTags.getIn(['form', 'errors', val]);
  }

  // change select number values to strings to work with ant design select inputs
  Object.keys(data).forEach(x => {
    if (['status', 'rating'].includes(x)) {
      data[x] = data[x].toString();
    }
  });

  return {
    isLoading: state.careGuideHelperTags.get('isLoading'),
    isSubmitting: state.careGuideHelperTags.getIn(['form', 'isSubmitting']),
    success: state.careGuideHelperTags.getIn(['form', 'success']),
    created_id: state.careGuideHelperTags.getIn(['form', 'created_id']),
    data: data,
    errors: errors,
    createdAt: state.entities.getIn(['careGuideHelperTags', ownProps.id, 'created_at'], null),
    updatedAt: state.entities.getIn(['careGuideHelperTags', ownProps.id, 'updated_at'], null),
  }
}

const mapDispatchToProps = dispatch => {
  return {
    load: (id, cb) => {
      dispatch(loadCareGuideHelperTag(id, cb));
    },
    update: (id, data, cb) => {
      dispatch(updateCareGuideHelperTag(id, data, cb));
    },
    create: (data, cb) => {
      dispatch(createCareGuideHelperTag(data, cb));
    },
    delete: (id, cb) => {
      dispatch(deleteCareGuideHelperTag(id, cb))
    },
    destroyForm: (formState) => {
      dispatch(careGuideHelperTagFormDestroy(formState));
    },
    sendMessage: (level, title, body, expires) => {
      dispatch(sendMessage(level, title, body, expires));
    },
  }
}

const CareGuideHelperTagFormContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(CareGuideHelperTagForm);

export default CareGuideHelperTagFormContainer;
